/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_DraftInputs */

const vi_status_order_draft = /** @type {(inputs: Status_Order_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp`)
};

/**

* @param {Status_Order_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_draft = /** @type {((inputs?: Status_Order_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_draft(inputs)
});